export default "__VITE_ASSET__860d2a05__"